export default {
  head_scripts: {
    title: 'Scripts do cabeçalho',
  },
  body_noscripts: {
    title: 'Noscripts do corpo',
    description: 'Injetar código imediatamente após a abertura do body',
  },
  google_site_verification: {
    title: 'Verificação do site Google',
    label: 'Código de verificação do site Google',
  },
  buttons: {
    save: 'Guardar',
  },
};
